const gql = (template: TemplateStringsArray) => template.join('');

export const issueIdsQuery = gql`
  query IssueIdsQuery($jql: String, $first: Int!, $isMaxResultsLimitEnabled: Boolean!) {
    issues(
      first: $first
      jql: $jql
      isMaxResultsLimitEnabled: $isMaxResultsLimitEnabled
    ) {
      nodes {
        ...GetIssueIdFragment
      }
    }
  }

  fragment GetIssueIdFragment on Issue {
    issueId
  }
`;

export const issuesByIdsQuery = gql`
  query IssuesByIdsQuery($issueIds: [Long!]!) {
    issuesByIds(issueIds: $issueIds) {
      issuekey {
        stringValue
      }
    }
  }
`;
